<div class="flex flex-col mb-5">
  <div class="flex justify-between">
    @if (titleComponent()) {
    <div class="title font-bold">
      {{ titleComponent() | translate }}
    </div>
    }
    @if (resizeService.isMobile()) {
    <span onKeyUp class="text-md! font-semibold" (click)="showInfoData()">
      info <i class="pi pi-user pl-1" style="color: #1e7f88"></i>
    </span>
    }
  </div>
</div>

@if (resizeService.isMobile()) {
<p-dialog [(visible)]="showDialogInfoData" [modal]="true" [header]="'Informazioni utenza'" [style]="{ width: '25rem' }">
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 bg-gray-100 p-6 rounded-lg">
    @for (item of attivitaInfo(); track item.title) {
    <div class="info-item">
      <label for="info" class="font-bold mb-2">
        {{ item.title | translate }}
      </label>
      <div id="info" class="text-base font-medium">
        {{ item.value || "--" }}
      </div>
    </div>
    }
  </div>
</p-dialog>
} @else {
@if (loading()) {
<div class="flex justify-between gap-4 bg-gray-100 p-6 rounded-lg mb-8 mt-6">
  @for (item of [1, 2, 3, 4]; track $index) {
  <div class="info-item">
    <p-skeleton width="8rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
    <p-skeleton width="12rem" height="1.5rem" styleClass="mt-4"></p-skeleton>
  </div>
  }
</div>
} @else {
<div class="flex justify-between gap-4 bg-gray-100 p-6 rounded-lg mb-8 mt-6">
  @for (item of attivitaInfo(); track item.title) {
  <div class="info-item">
    <span class="font-bold">
      {{ item.title | translate }}
    </span>
    <div class="color-secondary-text font-medium mt-4">
      {{ item.value || "--" }}
    </div>
  </div>
  }
</div>
}
}
